import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SendIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			d="M5.34386 7.67368L1.34082 2.95166C5.84302 2.40135 10.4061 2.62378 14.8335 3.60935C12.4922 7.49381 9.50484 10.95 6.00026 13.829L5.34386 7.67368ZM5.34386 7.67368L9.94004 5.70516"
			stroke="currentColor"
			strokeWidth="1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
))
